import { createRouter, createWebHistory } from 'vue-router';
import { accountRouters } from './account';

import type { IRouteConfig } from '@/types/common/router';
import { LoadingBar } from 'view-ui-plus';
import { AdminNames } from './routerNames';
import { singleRouters } from './single';
const routes: IRouteConfig[] = [
  ...singleRouters,
  //...accountRouters
];
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

export default router;
const permissions = JSON.parse(localStorage.getItem('userInfo') as any)?.permissions;
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  LoadingBar.start();
  next();

  // console.log(to.name);
  if(to.name!='single.home.noLogin'){
    document.title = `${to.query.name}-${to.meta.title}`;
  }
  // if (to.name ) {
  //   // 不包含，导航到指定页面
  //   next({ name: AdminNames.SingleActivity });
  // } else {
  //   document.title = `${to.meta.title}`;
  //   LoadingBar.start();
  //   next();
  // }
});

router.afterEach(() => {
  LoadingBar.finish();
  window.scrollTo(0, 0);
});
